<template>
  <layout-form>
    <input-last-name />
    <input-first-name />
    <input-email />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib/Layout/Form'
import InputLastName from './InputLastName'
import InputFirstName from './InputFirstName'
import InputEmail from './InputEmail'

export default {
  components: {
    LayoutForm,
    InputLastName,
    InputFirstName,
    InputEmail
  }
}
</script>
